import Link from 'next/link';
import s from 'styles/components/button';
import ArrowRight from 'public/icons/arrow-right.svg';

export default function Button ({
	type,
	className,
	onClick,
	styleName = 'dark',
	iconName = 'arrow-right',
	download = false,
	href = '#',
	target = '_self',
	children,
}) {
	const icons = {
		'arrow-right': <ArrowRight/>,
	};

	// Scrolls to a section.
	const scrollToSection = id => e => {
		e.preventDefault();

		const s = document.getElementById(id);
		if (!s) return;

		const y = s.offsetTop;
		window.scrollTo({top: y, left: 0, behavior: 'smooth'});
	};

	// The button icon.
	const Icon = () => (
		iconName && typeof icons[iconName] !== 'undefined' ? (
			<s.ButtonIcon>{icons[iconName]}</s.ButtonIcon>
		) : null
	);

	// The button contents.
	const Content = () => (
		<s.ButtonContents styleName={styleName} className={className}>
			{children}
			{iconName && <Icon/>}
		</s.ButtonContents>
	);

	// Prepare attributes that will always be added, regardless of the button type.
	const globalAttributes = {};
	if (download) globalAttributes.download = '';

	// Setup anchor scroll
	if (typeof href === 'string' && href.indexOf('#') === 0 && href.length > 1) {
		onClick = scrollToSection(href.replace('#', ''));
	}

	return type ? (
		<button onClick={onClick || null} type={type} {...globalAttributes}>
			<Content/>
		</button>
	) : (
		<Link {...globalAttributes} href={href || ''} passHref>
			<a onClick={onClick || null} target={target}>
				<Content/>
			</a>
		</Link>
	);
}
